import axios from 'axios';

// const API_URL = 'http://localhost:8000/api';
const API_URL = 'https://seethakalyanavaibhogame.com/skvadmin/api'; // Update with your Laravel backend URL

const register = async (userData) => {
  const response = await axios.post(`${API_URL}/register`, userData);
  return response.data;
};
const gustUser = async (userData) => {
  const response = await axios.post(`${API_URL}/gustUser`, userData);
  return response.data;
};
const verifyOtp = async (email, otp) => {
  const response = await axios.post(`${API_URL}/verify-otp`, { email, otp });
  return response.data;
};

const login = async (credentials) => {
  const response = await axios.post(`${API_URL}/login`, credentials);
  if (response.data.access_token) {
    localStorage.setItem('token', response.data.access_token);
    return { token: response.data.access_token, user: response.data.user };
  } else if (response.data.message === 'Email not verified') {
    return {
      message: response.data.message,
      email: credentials.email,
      requiresVerification: true
    };
  }
  return response.data;
};
const gustLogin = async (credentials) => {
  const response = await axios.post(`${API_URL}/gustUserLogin`, credentials);
  if (response.data.access_token) {
    localStorage.setItem('token', response.data.access_token);
    return { token: response.data.access_token, user: response.data.user };
  }else{
    return {
      message: response.data.message,
      email: credentials.email,
      requiresVerification: true
    };
  }
  return response.data;
};

const getMe = async (token) => {
  const response = await axios.get(`${API_URL}/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

const logout = async () => {
  const token = localStorage.getItem('token');
  await axios.post(`${API_URL}/logout`, null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  localStorage.removeItem('token');
};

const updateProfile = async (formData) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  };

  try {
    const response = await axios.post(
      `${API_URL}/update-profile`,
      formData,
      config
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to update profile';
  }
};

const uploadProfileImage = async (imageFile) => {
  const formData = new FormData();
  formData.append("image", imageFile);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  const response = await axios.post(`${API_URL}/upload-profile-image`, formData, config);
  return response.data;
};
const unsubscribe = async (data) => {
  const response = await axios.post(`${API_URL}/unsubscribe`, data);
  return response.data;
};

const getUserSubscriptionDetails = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await axios.get(`${API_URL}/getUserSubscriptionDetails`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data || {};
  } catch (error) {
    console.error('Error fetching user subscription details:', error);
    throw error.response?.data?.message || 'Failed to fetch subscription details';
  }
};

// Forgot Password Functions
const sendPasswordOtp = async (email, from = 'user', type = 'otp') => {
  const response = await axios.post(`${API_URL}/sendPasswordOtp`, {
    email,
    from,
    type
  });
  return response.data;
};

const validatePasswordOtp = async (email, otp, type = 'user') => {
  const response = await axios.post(`${API_URL}/validatePasswordOtp`, {
    email,
    otp,
    type
  });
  return response.data;
};

const getResetPasswordData = async (email, type, time) => {
  const response = await axios.post(`${API_URL}/getResetPasswordData`, {
    email,
    type,
    time
  });
  return response.data;
};

const resetPassword = async (email, password, password_confirmation, type = 'user') => {
  const response = await axios.post(`${API_URL}/chnagePassword`, {
    email,
    password,
    password_confirmation,
    type
  });
  return response.data;
};


const authService = {
  register,
  gustUser,
  verifyOtp,
  login,
  gustLogin,
  getMe,
  logout,
  updateProfile,
  uploadProfileImage,
  unsubscribe,
  getUserSubscriptionDetails,
  sendPasswordOtp,
  validatePasswordOtp,
  getResetPasswordData,
  resetPassword,
};

export default authService;